import React from 'react';
import cn from 'classnames';
import { useMergeClasses, useTheme } from '../../../../../../theme';
import Filter from '../../../Filter/ui/Filter';
import { CdnIcon } from '@shared/ui/CdnIcon';
import { useMediaQuery } from 'react-responsive';
const SegmentTab = ({ classes, isCompact, isActive, index, segment, count, onClick }) => {
    const { SegmentTab: defaultClasses } = useTheme('Shared').SegmentTabs;
    const css = useMergeClasses(defaultClasses, classes);
    const isSmallMobile = useMediaQuery({ maxWidth: 400 });
    const { isDisabled, isChecked, additional, title } = segment;
    const showIndex = isSmallMobile || (isCompact && !isActive);
    const showAdditional = additional && !showIndex;
    const label = showIndex ? index : title;
    const LabelElement = (React.createElement("span", { className: css.label },
        label,
        showAdditional && (React.createElement(React.Fragment, null,
            React.createElement("span", { className: css.dot }),
            additional))));
    return (React.createElement("div", { className: cn(css.root, { [css.active]: isActive, [css.disabled]: isDisabled }) },
        isChecked && (React.createElement("div", { className: css.checkedIcon },
            React.createElement(CdnIcon, { icon: "Info/Item Icluded" }))),
        React.createElement(Filter, { size: "large", color: "gray", label: LabelElement, isDisabled: isDisabled, isSelected: isActive, quantity: count || undefined, onClick: onClick })));
};
export default SegmentTab;
